import React, { Component } from 'react'
import c from 'classnames'
import PropTypes from 'prop-types'
import Image from 'src/components/image'
import handSrc from 'src/assets/hand.svg'

export class TapAnimation extends Component {
  static propTypes = {
    className: PropTypes.string,
    shouldTap: PropTypes.bool,
    onTapComplete: PropTypes.func,
  }

  static defaultProps = {
    className: '',
    shouldTap: false,
    onTapComplete: () => {},
  }

  state = {
    visible: false,
    tapping: false,
  }

  get className() {
    const { className } = this.props
    const { tapping, visible } = this.state
    return c('im-tap-animation', visible && 'visible', tapping && 'tapping', className)
  }

  componentDidUpdate = prevProps => {
    if (!prevProps.shouldTap && this.props.shouldTap) {
      const fadeDuration = 250
      const tapDuration = 1200
      const halfDuration = tapDuration * 0.5

      this.setState({ visible: true })

      setTimeout(() => {
        this.setState({ tapping: true })
      }, fadeDuration)

      setTimeout(() => {
        this.setState({ tapping: false })
      }, fadeDuration + halfDuration)

      setTimeout(() => {
        this.setState({ visible: false })
        this.props.onTapComplete(this)
      }, fadeDuration + tapDuration)
    }
  }

  render() {
    const { className } = this
    return (
      <div className={className}>
        <div className="target">
          <div className="bullseye" />
        </div>
        <Image className="hand" src={handSrc} alt="Tap Animation Hand" />
      </div>
    )
  }
}

export default TapAnimation
